//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//style
import './OurStory.scss'

//api
import { api } from '../../../../functions/api';

//custom components
import CustomInput from '../../../../components/basic/input';
import CustomAvatar from '../../../../components/basic/customAvatar';

//material-ui
import { Grid, Paper } from '@material-ui/core'

//other libraries

@inject('internal')
@inject('translate')
@observer
export default class OurStory extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    timeout = null

    handleOnChange = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateData()
        }, 500)
    }

    updateData = async() => {
        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'PATCH',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                showroom_title: this.showroom_title.state.value,
                description: this.description.state.value,
                our_story_title: this.our_story_title.state.value,
                our_story_description: this.our_story_description.state.value,
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    handleChangePhoto = async (data) => {
        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'POST',
            url: `lists/shops/${id}`,
            formData: true,
            // formDataPut: true,
            authorization: this.props.internal.user.access_token,
            params: {
                our_story_image: data
            },

        })

        if (update_data.success && update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.props.internal.photoWasChanged(null)
            return Promise.resolve(false)
        }
    }

    render () {
        return (
            <div className={'shopDetailContainer'}>
            <div className="content">
                <Grid container spacing={16} >
                    <Grid item xs={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.showroom_title = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.SHOWROOM_TITLE}
                                value={toJS(this.props.internal.dataForTable.showroom_title)}
                                id={"showroom-title"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.description = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.FOOTER_DESCRIPTION}
                                value={toJS(this.props.internal.dataForTable.description)}
                                id={"description"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                multiline
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.our_story_title = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.OUR_STORY_TITLE}
                                value={toJS(this.props.internal.dataForTable.our_story_title)}
                                id={"our_story_title"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.our_story_description = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.OUR_STORY_DESCRIPTION}
                                value={toJS(this.props.internal.dataForTable.our_story_description)}
                                id={"our_story_description"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                multiline
                            />
                            <div className={'ourStoryImage'}>
                                <CustomAvatar
                                    src={`${toJS(this.props.internal.dataForTable.our_story_image)}`}
                                    actionUploadPhoto={this.handleChangePhoto}
                                    disableEdit={false}
                                />
                            </div>
                        </Paper>
                    </Grid>
                    
                    {/* <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.contact_email = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.CONTACT_PHONE}
                                value={toJS(this.props.internal.dataForTable.contact_email)}
                                id={"contact_email"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.contact_phone = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.CONTACT_EMAIL}
                                value={toJS(this.props.internal.dataForTable.contact_phone)}
                                id={"contact_phone"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.latitude = ref)}
                                text={this.props.translate.i18n.GLOBAL.CONTACT.LATITUDE}
                                value={toJS(this.props.internal.dataForTable.latitude)}
                                id={"latitude"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                            <CustomInput
                                ref={ref => (this.latitude = ref)}
                                text={this.props.translate.i18n.GLOBAL.CONTACT.LONGITUDE}
                                value={toJS(this.props.internal.dataForTable.latitude)}
                                id={"latitude"}
                                className={"w-100"}
                                change={this.handleOnChange}
                                
                            />
                        </Paper>
                    </Grid>*/}
                </Grid>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/shops/detail/ourStory/OurStory.jsx